import api from './api';

// Get all exceptions for a tenant
export const getAllExceptions = async (tenantId, params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.type) queryParams.append('type', params.type);
  if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  
  const queryString = queryParams.toString();
  const url = `/exceptions/tenant/${tenantId}${queryString ? `?${queryString}` : ''}`;
  
  const response = await api.get(url);
  return response.data;
};

// Get exception by ID
export const getExceptionById = async (id) => {
  const response = await api.get(`/exceptions/${id}`);
  return response.data;
};

// Create new exception
export const createException = async (exceptionData) => {
  const response = await api.post('/exceptions', exceptionData);
  return response.data;
};

// Update exception
export const updateException = async (id, exceptionData) => {
  const response = await api.put(`/exceptions/${id}`, exceptionData);
  return response.data;
};

// Delete exception
export const deleteException = async (id) => {
  const response = await api.delete(`/exceptions/${id}`);
  return response.data;
};

// Check for conflicts before creating exception
export const checkConflicts = async (exceptionData) => {
  const response = await api.post('/exceptions/check-conflicts', exceptionData);
  return response.data;
};

// Create exception with confirmation (cancel conflicting appointments)
export const createExceptionWithConfirmation = async (exceptionData) => {
  const response = await api.post('/exceptions/with-confirmation', {
    exceptionData: exceptionData,
    cancelAppointments: true
  });
  return response.data;
};
